module.exports = __webpack_public_path__ + "img/Productsystem.b9dc5eec.png";